export function seatWidgetAjax(
  SCHEDULE_EID,
  chartWidth,
  chartRatio,
  isVertical
) {
  // const screenshotSecret = myvars.screenshotSecret
  const chartHeight = Math.round(chartWidth * chartRatio)
  // const domain =
  //   location.host === 'ticketsfr.shenyun.com'
  //     ? 'tickets.shenyun.com'
  //     : location.host
  // const domain =
  //   location.host === 'ticketsv5.sydev.info'
  //     ? 'tickets.shenyun.com'
  //     : location.host

  // const chartWidgetImgSrc = `https://api.screenshotlayer.com/api/capture?access_key=${screenshotKey}&url=http://${domain()}/event/view/widget-html5-seating-chart/schedule/${SCHEDULE_EID}/v/1?selectseats=${selectSeatsEid}&viewport=${chartWidth}x${chartHeight}&width=${chartWidth}`

  // const chartWidgetImgSrc_h = `https://api.screenshotlayer.com/api/capture?access_key=${screenshotKey}&url=http://${domain()}/event/view/widget-html5-seating-chart/schedule/${SCHEDULE_EID}/v/0?selectseats=${selectSeatsEid}&viewport=${chartHeight}x${chartWidth}&width=${chartHeight}`

  const chartWidgetImgSrc = `/event/view/widget-html5-seating-chart/schedule/${SCHEDULE_EID}/v/1`

  const chartWidgetImgSrc_h = `/event/view/widget-html5-seating-chart/schedule/${SCHEDULE_EID}/v/0`

  if (isVertical) {
    return chartWidgetImgSrc
  } else {
    return chartWidgetImgSrc_h
  }
}

export function seatWidgetIframe(
  SCHEDULE_EID,
  selectSeatsEid,
  chartWidth,
  chartRatio,
  isVertical
) {
  // const screenshotSecret = myvars.screenshotSecret
  // const chartHeight = Math.round(chartWidth * chartRatio)
  // const domain =
  //   location.host === 'ticketsfr.shenyun.com'
  //     ? 'tickets.shenyun.com'
  //     : location.host
  // const domain =
  //   location.host === 'ticketsv5.sydev.info'
  //     ? 'tickets.shenyun.com'
  //     : location.host

  // const chartWidgetImgSrc = `https://api.screenshotlayer.com/api/capture?access_key=${screenshotKey}&url=http://${domain()}/event/view/widget-html5-seating-chart/schedule/${SCHEDULE_EID}/v/1?selectseats=${selectSeatsEid}&viewport=${chartWidth}x${chartHeight}&width=${chartWidth}`

  // const chartWidgetImgSrc_h = `https://api.screenshotlayer.com/api/capture?access_key=${screenshotKey}&url=http://${domain()}/event/view/widget-html5-seating-chart/schedule/${SCHEDULE_EID}/v/0?selectseats=${selectSeatsEid}&viewport=${chartHeight}x${chartWidth}&width=${chartHeight}`

  const chartWidgetImgSrc = `/event/view/widget-html5-seating-chart/schedule/${SCHEDULE_EID}/doNotRefreshCart/1/v/1?selectSeats=${selectSeatsEid}`

  const chartWidgetImgSrc_h = `/event/view/widget-html5-seating-chart/schedule/${SCHEDULE_EID}/doNotRefreshCart/1/v/0?selectSeats=${selectSeatsEid}`

  if (isVertical) {
    return chartWidgetImgSrc
  } else {
    return chartWidgetImgSrc_h
  }
}

// export default seatWidgetAjax
